import template from './clients.html';

export default angular.module('eventix.dashboard.company.clients', [])
    .config(function($stateProvider) {
        $stateProvider.state('eventix.dashboard.company.clients', {
            url: '/clients',
            views: {
                'dashboard@eventix.dashboard': {
                    component: 'clientManager',
                },
            },
            data: {
                crumb: 'common.menu.company.clients',
                requiredRoles: ['Company Admin'],
            },
        });
    })
    .component('clientManager', {
        controller: ClientManagerController,
        templateUrl: template,
        bindings: {
            isAdmin: '<',
            user: '<',
            company: '<',
        },
    }).name;

function ClientManagerController(Locales) {
    const $ctrl = this;

    $ctrl.$onInit = function () {
        $ctrl.newDashboardRedirect = NEW_DASHBOARD_ROOT + 'profile/clients?legacy=true&locale='+Locales.selected;

    };
}
